// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-flexbox-grid';

import Button from '../common/ButtonComp';
import './AdminComp.css';
import AdminActions from '../actions/admin.actions';

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

class StatsComp extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const {
      adminActions: { getUsersStats, getProjectsStats }
    } = this.props;
    getUsersStats();
    getProjectsStats();
  }

  render() {
    const { usersStats, projectsStats } = this.props;
    const userData = usersStats.map((ud) => ({
      name: `${ud._id.day}/${ud._id.month}/${ud._id.year}`,
      date: new Date(`${ud._id.year}/${ud._id.month}/${ud._id.day}`),
      users: ud.count
    }));
    const projectData = projectsStats.map((pd) => ({
      name: `${pd._id.day}/${pd._id.month}/${pd._id.year}`,
      date: new Date(`${pd._id.year}/${pd._id.month}/${pd._id.day}`),
      projects: pd.count
    }));

    const allDates = [
      ...new Set([].concat(projectData.map((a) => a.name), userData.map((a) => a.name)))
    ];
    const allData = allDates
      .map((d) => {
        const user = userData.find((u) => u.name === d) || { users: 0 };
        const project = projectData.find((u) => u.name === d) || { projects: 0 };

        return { name: d, ...user, ...project };
      })
      .sort((a, b) => b.date - a.date);
    const appDataArray = chunk(allData, 28);
    const yAxisMax = Math.max(
      ...[].concat(projectData.map((a) => a.projects), userData.map((a) => a.users))
    );

    return (
      <div className="stats">
        <h1 className="stats-header">STATS</h1>
        <div className="content">
          {appDataArray.map((d, i) => (
            <div key={i} className="space-medium-bottom">
              {renderChart(d, yAxisMax)}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

function renderChart(data, yAxisMax) {
  return (
    <AreaChart
      width={737}
      height={200}
      data={data}
      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
    >
      <defs>
        <linearGradient id="colorUser" x1="0" y1="0" x2="0" y2="1">
          <stop offset="3%" stopColor="#8884d8" stopOpacity={0.9} />
          <stop offset="97%" stopColor="#8884d8" stopOpacity={0} />
        </linearGradient>
        <linearGradient id="colorProject" x1="0" y1="0" x2="0" y2="1">
          <stop offset="3%" stopColor="#82ca9d" stopOpacity={0.9} />
          <stop offset="97%" stopColor="#82ca9d" stopOpacity={0} />
        </linearGradient>
      </defs>
      <YAxis type="number" domain={[0, yAxisMax + 10]} />
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Area
        type="monotone"
        dataKey="projects"
        stackId="1"
        stroke="#82ca9d"
        fillOpacity={1}
        fill="url(#colorProject)"
      />
      <Area
        type="monotone"
        dataKey="users"
        stackId="2"
        stroke="#8884d8"
        fillOpacity={1}
        fill="url(#colorUser)"
      />
    </AreaChart>
  );
}

function mapStateToProps(state) {
  return {
    me: state.me,
    usersStats: state.admin.usersStats || [],
    projectsStats: state.admin.projectsStats || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    adminActions: bindActionCreators(AdminActions, dispatch)
  };
}

function chunk(arr, n) {
  if (!arr.length) return [];
  return [arr.slice(0, n)].concat(chunk(arr.slice(n), n));
}

export default connect(mapStateToProps, mapDispatchToProps)(StatsComp);



// WEBPACK FOOTER //
// ./src/admin/StatsComp.js